import * as v from "valibot";

import { rpcContract } from "../rpc";

export const setWaitingListLinkRpcContract = rpcContract({
  name: "set-waiting-list-link",
  paramsSchema: v.object({
    linkId: v.optional(v.string()),
    influencerId: v.pipe(
      v.string("influencerId must be a string"),
      v.uuid("Invalid influencerId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
    ),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SetWaitingListLinkParams = v.InferOutput<(typeof setWaitingListLinkRpcContract)["paramsSchema"]>;
export type SetWaitingListLinkResult = v.InferOutput<(typeof setWaitingListLinkRpcContract)["resultSchema"]>;
